module.exports = __webpack_public_path__ + "img/03-金佛山.5cc4fb26.jpg";